import {Component, Input, OnInit} from '@angular/core';
import {Config} from "../../../config/config";
import {User} from "../../../user/user";
import {ChosenPlan} from "../payment-info/models/plan.model";
import {CheckoutService} from "../../../auth/checkout/checkout.service";
import {LanguageService} from "../../services/language/language.service";


@Component({
    selector: 'db-google-apple-pay',
    templateUrl: './google-apple-pay.component.html',
    styleUrls: ['./google-apple-pay.component.scss'],
    standalone: false
})
export class GoogleApplePayComponent implements OnInit {

  @Input() chosenPlan: ChosenPlan;
  @Input() newPrice: any;
  @Input() user: User;

  constructor(
    private _checkoutService: CheckoutService,
    private _languageService: LanguageService
  ) {
  }

  ngOnInit() {
    this._loadGoogleApple();
  }

  private _loadGoogleApple(): void {
    const options = {
      paymentMethods: {
        applePay: 'always',
        googlePay: 'always',
      },
      layout: {
        maxColumns: 2,
        overflow: 'never'
      },
      buttonHeight: 40,
      buttonTheme: {
        applePay: 'black',
        googlePay: 'white',
      },
      buttonType: {
        applePay: 'plain',
        googlePay: 'plain'
      }
    };
    const stripeConfig: any = {};

    // Set locale from language service
    const currentLanguage = this._languageService.getCurrentLanguage();
    if (currentLanguage) {
      stripeConfig.locale = currentLanguage;
    }

    const _stripe = window['Stripe'](Config.stripeKey, stripeConfig);
    const elements = _stripe.elements({
      mode: 'payment',
      amount: 100,

      currency: 'usd',
      setupFutureUsage: 'off_session',
      captureMethod: 'manual',
    });
    const expressCheckoutElement = elements.create('expressCheckout', options)
    expressCheckoutElement.mount('#express-checkout-element');
    const user = this.user;
    const _checkoutService = this._checkoutService;
    expressCheckoutElement.on('ready', function(event) {
      if (event?.availablePaymentMethods) {
        document.querySelector('.db-apple-google-wrap') && document.querySelector('.db-apple-google-wrap').classList.remove('ds-lazy-load');
      }
    });
    expressCheckoutElement.on('confirm', async function(event) {
      const {error, confirmationToken} = await _stripe.createConfirmationToken({
        elements
      });
      if (!error && confirmationToken) {
        _checkoutService.GoogleApple.next(confirmationToken.id);
      }
    });
  }


}
